import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const AppleImg = () => {
  return (
    <StaticImage
      placeholder="blurred"
      src="../../../../../images/AppStoreImg.png"
      alt="Encuentra Kolyy app en App Store"
    />
  );
};

export default AppleImg;
